import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Button, Grid } from '@mui/material';

interface RecipeEditorAddNewButtonProps {
    setSelectedSection: (section: RecipeSection | null) => void;
}

const RecipeEditorAddNewButton = ({ setSelectedSection }: RecipeEditorAddNewButtonProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    function getRandomColor() {
        const letters = 'ABCDEF'.split('');
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * letters.length)];
        }
        return color;
    }

    const emptySection: RecipeSection = {
        circadianLength: 24,
        sectionColor: {
            background: getRandomColor(),
            text: '#000000'
        },
        id: '',
        name: '',
        orderPosition: 1,
        repeatNum: 1,
        circadianEvents: []
    };

    function onAddNewSection() {
        setSelectedSection(emptySection);
    }

    return (
        <>
            {formData.readOnly ? null : (
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Button variant="contained" onClick={onAddNewSection} startIcon={<AddBoxIcon />}>
                        {i18n('add_new_section_button')}
                    </Button>
                </Grid>
            )}
        </>
    );
};

export default React.memo(RecipeEditorAddNewButton);
